export default __webpack_public_path__ + "img/57b44c4afcb5da299af7d60014b80db4.svg";